"use client";

import { c as _c } from "react/compiler-runtime";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { useGetIntl } from "@repo/i18n/intl/client";
import { cn } from "@repo/lib";
import { useRouter } from "next/navigation";
import { type Usable, useRef } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { useAnalytics } from "use-analytics";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { getCountryFlagEmoji } from "@repo/lib";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@repo/components/atoms/shadcn/command";
import { LocationSelectorClient_Localization_Fragment } from "./graphql";
function LocaleList(t0) {
  const $ = _c(24);
  const {
    className,
    dictionaryPromise,
    lang,
    localizationMasked
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  const router = useRouter();
  const {
    track
  } = useAnalytics() || {};
  const popoverRef = useRef(null);
  let t2;
  if ($[3] !== localizationMasked || $[4] !== router || $[5] !== track) {
    const localization = readFragmentShopifyStorefront(LocationSelectorClient_Localization_Fragment, localizationMasked);
    t2 = localization.availableCountries.flatMap(availableCountry => <CommandGroup heading={<div className="flex items-center gap-2"><span className="text-2xl leading-none">{getCountryFlagEmoji(availableCountry.isoCode)}</span><span>{availableCountry.isoCode} ({availableCountry.name})</span></div>} key={availableCountry.isoCode} className="flex flex-col gap-2">{availableCountry.availableLanguages.map(availableLanguage => {
        const BCP47LanguageTag = `${availableLanguage.isoCode.toLocaleLowerCase()}-${availableCountry.isoCode}`;
        return <CommandItem key={BCP47LanguageTag} value={BCP47LanguageTag} onSelect={value => {
          popoverRef.current?.hidePopover();
          let canonicalLocale;
          ;
          try {
            [canonicalLocale] = Intl.getCanonicalLocales(value);
          } catch (t3) {
            const error = t3;
            console.error(error);
          }
          if (track) {
            track("change_locale", {
              locale: canonicalLocale
            });
          }
          router.push(`/${canonicalLocale}`);
        }}><span className="flex gap-1"><span aria-label="Available country">{availableCountry.name}</span><span className="before:content-['('] after:content-[')']" aria-label="Available language">{availableLanguage.endonymName}</span></span></CommandItem>;
      })}</CommandGroup>);
    $[3] = localizationMasked;
    $[4] = router;
    $[5] = track;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const BCP47LanguageTagCommandItems = t2;
  let t3;
  if ($[7] !== className) {
    t3 = cn(className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== intl) {
    t4 = intl.formatMessage({
      defaultMessage: "Enter country name",
      description: "Text for a placeholder for a country name",
      id: "tqIifz"
    });
    $[9] = intl;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <CommandInput className="border-none focus:ring-0" placeholder={t4} />;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== intl) {
    t6 = intl.formatMessage({
      defaultMessage: "No results",
      description: "Text for a message when there are no results",
      id: "bJETaD"
    }, {
      results: 0
    });
    $[13] = intl;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <CommandEmpty>{t6}</CommandEmpty>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== BCP47LanguageTagCommandItems || $[18] !== t7) {
    t8 = <menu><CommandList asChild={true}>{t7}{BCP47LanguageTagCommandItems}</CommandList></menu>;
    $[17] = BCP47LanguageTagCommandItems;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t5 || $[22] !== t8) {
    t9 = <Command className={t3}>{t5}{t8}</Command>;
    $[20] = t3;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export function LocationSelectorClient(t0) {
  const $ = _c(56);
  const {
    className,
    dictionaryPromise,
    lang,
    localizationMasked
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  let localization;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== className || $[4] !== intl || $[5] !== localizationMasked) {
    localization = readFragmentShopifyStorefront(LocationSelectorClient_Localization_Fragment, localizationMasked);
    if ($[16] !== className) {
      t8 = cn("fixed inset-0 p-4 w-full max-w-3xl", "transition-discrete transition-all duration-300 ease-in-out", "opacity-0 open:opacity-100 open:translate-x-0 starting:open:opacity-0", "backdrop:bg-background/25 backdrop:backdrop-blur-md", "overflow-y-auto max-h-screen", "gap-x-8 open:grid grid-cols-2 items-start md:grid-flow-col place-content-center", className);
      $[16] = className;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t9 = "location-selector";
    t10 = "auto";
    t5 = "grid gap-4 justify-start items-start";
    let t11;
    if ($[18] !== intl) {
      t11 = intl.formatMessage({
        defaultMessage: "Location settings",
        description: "Text for the title of a location settings dialog in the LocationDialog component",
        id: "RwibOl"
      });
      $[18] = intl;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    if ($[20] !== t11) {
      t6 = <h2 className="text-lg uppercase">{t11}</h2>;
      $[20] = t11;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    let t12;
    if ($[22] !== intl) {
      t12 = intl.formatMessage({
        defaultMessage: "Choose your location to view content available to you",
        description: "Text for the description of a location settings dialog in the LocationDialog component",
        id: "Me9s/b"
      });
      $[22] = intl;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    if ($[24] !== t12) {
      t7 = <span className="text-sm">{t12}</span>;
      $[24] = t12;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    t4 = "flex gap-4 justify-start items-start";
    t2 = "text-7xl leading-none";
    t3 = getCountryFlagEmoji(localization.country.isoCode);
    $[3] = className;
    $[4] = intl;
    $[5] = localizationMasked;
    $[6] = localization;
    $[7] = t10;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    localization = $[6];
    t10 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t11;
  if ($[26] !== t2 || $[27] !== t3) {
    t11 = <span className={t2}>{t3}</span>;
    $[26] = t2;
    $[27] = t3;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== localization.country.name) {
    t12 = <span aria-label="Current country">{localization.country.name}</span>;
    $[29] = localization.country.name;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== localization.language.name) {
    t13 = <span className="before:content-['('] after:content-[')']" aria-label="Current language">{localization.language.name}</span>;
    $[31] = localization.language.name;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <span className="flex gap-1">{t12}{t13}</span>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t11 || $[37] !== t14 || $[38] !== t4) {
    t15 = <div className={t4}>{t11}{t14}</div>;
    $[36] = t11;
    $[37] = t14;
    $[38] = t4;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7) {
    t16 = <div className={t5}>{t6}{t7}{t15}</div>;
    $[40] = t15;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== className || $[46] !== dictionaryPromise || $[47] !== lang || $[48] !== localizationMasked) {
    t17 = <LocaleList className={className} dictionaryPromise={dictionaryPromise} lang={lang} localizationMasked={localizationMasked} />;
    $[45] = className;
    $[46] = dictionaryPromise;
    $[47] = lang;
    $[48] = localizationMasked;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  let t18;
  if ($[50] !== t10 || $[51] !== t16 || $[52] !== t17 || $[53] !== t8 || $[54] !== t9) {
    t18 = <section className={t8} id={t9} popover={t10}>{t16}{t17}</section>;
    $[50] = t10;
    $[51] = t16;
    $[52] = t17;
    $[53] = t8;
    $[54] = t9;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  return t18;
}
export default LocationSelectorClient;